// import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';
// import Navbar from './Navbar';
// import FooterSection from './FooterSection';
// import './ContactEnquiryPage.css';

// export default function ContactEnquiryPage() {
//   const [activeTab, setActiveTab] = useState('enquiry'); // 'enquiry' | 'message'
  
//   // Dynamic Courses for Enquiry Form
//   const [courses, setCourses] = useState([]);
//   const [loadingCourses, setLoadingCourses] = useState(true);

//   // States for Admission Enquiry Form
//   const [enquiryData, setEnquiryData] = useState({
//     studentName: '',
//     emailAddress: '',
//     mobileNumber: '',
//     alternativeMobileNumber: '',
//     highestQualification: 'Graduate (UG)',
//     state: 'Tamil Nadu',
//     city: '',
//     programInterested: '',
//     isWorkingProfessional: 'No',
//     additionalMessage: ''
//   });

//   // States for Send Message Form
//   const [messageData, setMessageData] = useState({
//     fullName: '',
//     emailAddress: '',
//     phoneNumber: '',
//     subject: 'General Enquiry',
//     message: ''
//   });

//   const [alert, setAlert] = useState({ type: '', message: '' });
//   const [submitting, setSubmitting] = useState(false);

//   const indianStates = [
//     'Tamil Nadu', 'Andhra Pradesh', 'Karnataka', 'Kerala', 'Telangana',
//     'Maharashtra', 'Gujarat', 'Delhi', 'Puducherry', 'West Bengal',
//     'Uttar Pradesh', 'Bihar', 'Rajasthan', 'Punjab', 'Haryana'
//   ];

//   const qualifications = [
//     '10th Pass',
//     '10+2 / Higher Secondary',
//     'Diploma',
//     'Graduate (UG)',
//     'Post Graduate (PG)',
//     'Doctorate / Ph.D.'
//   ];

//   const subjects = [
//     'General Enquiry',
//     'Fee Structure & Payment',
//     'Certificates & Transcripts',
//     'Course Details & Syllabus',
//     'Exam & Results',
//     'Technical / Portal Support'
//   ];

//   // Fetch courses dynamically
//   useEffect(() => {
//     const fetchCourses = async () => {
//       try {
//         const res = await fetch('https://metapi.emedhatechnologies.com/api/courses/courses');
//         const data = await res.json();
//         if (data.success && data.data.length > 0) {
//           setCourses(data.data);
//           setEnquiryData((prev) => ({ ...prev, programInterested: data.data[0].course_name }));
//         }
//       } catch (err) {
//         console.error('Error loading courses:', err);
//       } finally {
//         setLoadingCourses(false);
//       }
//     };
//     fetchCourses();
//   }, []);

//   const handleEnquiryChange = (e) => {
//     setEnquiryData({ ...enquiryData, [e.target.name]: e.target.value });
//   };

//   const handleMessageChange = (e) => {
//     setMessageData({ ...messageData, [e.target.name]: e.target.value });
//   };

//   // Submit Admission Enquiry Form
//   const handleEnquirySubmit = async (e) => {
//     e.preventDefault();
//     setAlert({ type: '', message: '' });
//     setSubmitting(true);

//     try {
//       const res = await fetch('https://metapi.emedhatechnologies.com/api/students/enquiry/submit', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(enquiryData)
//       });
//       const data = await res.json();

//       if (data.success) {
//         setAlert({ type: 'success', message: data.message });
//         setEnquiryData({
//           studentName: '',
//           emailAddress: '',
//           mobileNumber: '',
//           alternativeMobileNumber: '',
//           highestQualification: 'Graduate (UG)',
//           state: 'Tamil Nadu',
//           city: '',
//           programInterested: courses[0]?.course_name || '',
//           isWorkingProfessional: 'No',
//           additionalMessage: ''
//         });
//       } else {
//         setAlert({ type: 'error', message: data.message || 'Submission failed.' });
//       }
//     } catch (err) {
//       setAlert({ type: 'error', message: 'Server error. Please try again later.' });
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   // Submit Contact Message Form
//   const handleContactSubmit = async (e) => {
//     e.preventDefault();
//     setAlert({ type: '', message: '' });
//     setSubmitting(true);

//     try {
//       const res = await fetch('https://metapi.emedhatechnologies.com/api/students/contact/message', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(messageData)
//       });
//       const data = await res.json();

//       if (data.success) {
//         setAlert({ type: 'success', message: data.message });
//         setMessageData({
//           fullName: '',
//           emailAddress: '',
//           phoneNumber: '',
//           subject: 'General Enquiry',
//           message: ''
//         });
//       } else {
//         setAlert({ type: 'error', message: data.message || 'Submission failed.' });
//       }
//     } catch (err) {
//       setAlert({ type: 'error', message: 'Server error. Please try again later.' });
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   return (
//     <>
//       <Navbar />
//       <div className="contact-page-wrapper">
        
//         {/* Header Hero Banner */}
//         <section className="contact-hero-banner">
//           <div className="banner-inner-container">
//             <nav className="breadcrumb-nav">
//               <Link to="/" className="breadcrumb-link">Home</Link> / <span>Contact &amp; Enquiry</span>
//             </nav>
//             <h1>Contact &amp; Enquiry</h1>
//             <p>Reach out to CDOE, EDULEARNER — we are here to help you.</p>
//           </div>
//         </section>

//         {/* Dual Layout Section */}
//         <section className="contact-main-body">
//           <div className="contact-container grid-dual-layout">
            
//             {/* LEFT SIDEBAR: Get In Touch Info */}
//             <div className="contact-sidebar-info">
//               <h2 className="sidebar-heading">Get in Touch</h2>

//               <div className="info-item-block">
//                 <div className="info-icon-box">📍</div>
//                 <div className="info-text-box">
//                   <h4>Address</h4>
//                   <p>
//                     Centre for Distance and Online Education,<br />
//                     EDULEARNER Main Campus,<br />
//                     Thiruvannamalai – 606601,<br />
//                     Tamil Nadu, India
//                   </p>
//                 </div>
//               </div>

//               <div className="info-item-block">
//                 <div className="info-icon-box">📞</div>
//                 <div className="info-text-box">
//                   <h4>Phone</h4>
//                   <p>+91-4565-241386</p>
//                   <p>+91-4565-228080</p>
//                   <span className="toll-free-tag">Toll Free: 1800-425-1386</span>
//                 </div>
//               </div>

//               <div className="info-item-block">
//                 <div className="info-icon-box">✉️</div>
//                 <div className="info-text-box">
//                   <h4>Email</h4>
//                   <p>cdoe@edulearner.ac.in</p>
//                   <p>admission.cdoe@edulearner.ac.in</p>
//                 </div>
//               </div>

//               <div className="info-item-block">
//                 <div className="info-icon-box">⏰</div>
//                 <div className="info-text-box">
//                   <h4>Office Hours</h4>
//                   <p>Mon – Fri: 9:30 AM – 5:30 PM</p>
//                   <p>Saturday: 9:30 AM – 1:00 PM</p>
//                   <p className="closed-tag">Sunday: Closed</p>
//                 </div>
//               </div>

//               {/* Social Links */}
//             {/* Social Links */}
// <div className="social-links-block">
//   <h4>Follow Us</h4>
//   <div className="social-icons-row">
    
//     {/* WhatsApp */}
//     <a 
//       href="https://wa.me/917810027373" 
//       target="_blank" 
//       rel="noopener noreferrer" 
//       className="social-pill whatsapp" 
//       aria-label="WhatsApp"
//       title="WhatsApp"
//     >
//       <svg viewBox="0 0 24 24" fill="currentColor">
//         <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91C2.13 13.66 2.59 15.36 3.45 16.86L2.05 22L7.3 20.62C8.75 21.41 10.38 21.83 12.04 21.83C17.5 21.83 21.95 17.38 21.95 11.92C21.95 9.27 20.92 6.78 19.05 4.91C17.18 3.03 14.69 2 12.04 2M12.05 3.67C14.25 3.67 16.31 4.53 17.87 6.09C19.42 7.65 20.28 9.72 20.28 11.92C20.28 16.46 16.58 20.15 12.04 20.15C10.56 20.15 9.11 19.76 7.85 19L7.55 18.83L4.43 19.65L5.26 16.61L5.06 16.29C4.24 15 3.8 13.47 3.8 11.91C3.81 7.37 7.5 3.67 12.05 3.67M9.53 7.5C9.35 7.5 9.06 7.57 8.81 7.84C8.56 8.11 7.85 8.78 7.85 10.14C7.85 11.5 8.84 12.82 8.98 13C9.11 13.19 10.79 15.79 13.35 16.9C15.48 17.82 15.91 17.63 16.37 17.59C16.83 17.55 17.85 16.99 18.06 16.4C18.27 15.81 18.27 15.3 18.21 15.2C18.15 15.09 18 15.03 17.72 14.89C17.44 14.75 16.08 14.08 15.82 14C15.56 13.9 15.38 13.85 15.2 14.12C15.02 14.39 14.5 15.03 14.34 15.22C14.18 15.4 14.03 15.42 13.75 15.28C13.47 15.15 12.57 14.85 11.5 13.9C10.67 13.16 10.11 12.24 9.95 11.96C9.79 11.69 9.93 11.54 10.07 11.4C10.2 11.27 10.35 11.07 10.5 10.9C10.64 10.73 10.69 10.6 10.78 10.42C10.87 10.23 10.83 10.07 10.76 9.93C10.69 9.8 10.16 8.5 9.94 7.97C9.72 7.45 9.5 7.52 9.35 7.51L8.98 7.5H9.53Z"/>
//       </svg>
//     </a>

//     {/* Instagram */}
//     <a 
//       href="https://www.instagram.com/alagappauniversitytpet?igsh=dWQxNzJqdGx4b2Vu" 
//       target="_blank" 
//       rel="noopener noreferrer" 
//       className="social-pill instagram" 
//       aria-label="Instagram"
//       title="Instagram"
//     >
//       <svg viewBox="0 0 24 24" fill="currentColor">
//         <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
//       </svg>
//     </a>

//     {/* Facebook */}
//     <a 
//       href="https://www.facebook.com/share/1DBkWkki8w/" 
//       target="_blank" 
//       rel="noopener noreferrer" 
//       className="social-pill facebook" 
//       aria-label="Facebook"
//       title="Facebook"
//     >
//       <svg viewBox="0 0 24 24" fill="currentColor">
//         <path d="M22.675 0h-21.35c-.732 0-1.325.593-1.325 1.325v21.351c0 .731.593 1.324 1.325 1.324h11.495v-9.294h-3.128v-3.622h3.128v-2.671c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.795.143v3.24l-1.918.001c-1.504 0-1.795.715-1.795 1.763v2.313h3.587l-.467 3.622h-3.12v9.293h6.116c.73 0 1.323-.593 1.323-1.325v-21.35c0-.732-.593-1.325-1.325-1.325z"/>
//       </svg>
//     </a>

//     {/* X (Twitter) */}
//     <a 
//       href="https://x.com/meteducentre?s=11" 
//       target="_blank" 
//       rel="noopener noreferrer" 
//       className="social-pill twitter-x" 
//       aria-label="X (Twitter)"
//       title="X (Twitter)"
//     >
//       <svg viewBox="0 0 24 24" fill="currentColor">
//         <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
//       </svg>
//     </a>

//     {/* YouTube */}
//     <a 
//       href="https://youtube.com/@alagappauniversitytpet?si=Kc4m6JIioH8qUCpY" 
//       target="_blank" 
//       rel="noopener noreferrer" 
//       className="social-pill youtube" 
//       aria-label="YouTube"
//       title="YouTube"
//     >
//       <svg viewBox="0 0 24 24" fill="currentColor">
//         <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
//       </svg>
//     </a>

//     {/* Google Maps Pin */}
//     <a 
//       href="https://maps.app.goo.gl/4ttrRSq6B4H4z2hAA" 
//       target="_blank" 
//       rel="noopener noreferrer" 
//       className="social-pill gmaps" 
//       aria-label="Google Maps"
//       title="Google Maps"
//     >
//       <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//         <path d="M12 21s-8-4.5-8-11.8A8 8 0 0 1 12 2a8 8 0 0 1 8 7.2c0 7.3-8 11.8-8 11.8z"/>
//         <circle cx="12" cy="10" r="3"/>
//       </svg>
//     </a>

//   </div>
// </div>


//             </div>

//             {/* RIGHT SIDE: Tab Toggle & Form Card */}
//             <div className="contact-forms-area">
              
//               {/* Tab Switch Buttons */}
//               <div className="form-toggle-pill-wrapper">
//                 <button
//                   className={`toggle-tab-btn ${activeTab === 'enquiry' ? 'active' : ''}`}
//                   onClick={() => { setActiveTab('enquiry'); setAlert({ type: '', message: '' }); }}
//                 >
//                   Admission Enquiry
//                 </button>
//                 <button
//                   className={`toggle-tab-btn ${activeTab === 'message' ? 'active' : ''}`}
//                   onClick={() => { setActiveTab('message'); setAlert({ type: '', message: '' }); }}
//                 >
//                   Send a Message
//                 </button>
//               </div>

//               {/* Alert Feedback */}
//               {alert.message && (
//                 <div className={`form-alert-box ${alert.type}`}>
//                   {alert.message}
//                 </div>
//               )}

//               {/* FORM 1: Admission Enquiry Form */}
//               {activeTab === 'enquiry' && (
//                 <div className="form-card-shell">
//                   <div className="card-top-blue">
//                     <h3>Admission Enquiry Form</h3>
//                     <p>Our team will respond within 24 working hours</p>
//                   </div>

//                   <form onSubmit={handleEnquirySubmit} className="card-body-padding">
                    
//                     <div className="form-row-2col">
//                       <div className="field-group">
//                         <label>Student Name *</label>
//                         <input
//                           type="text"
//                           name="studentName"
//                           placeholder="Full name"
//                           value={enquiryData.studentName}
//                           onChange={handleEnquiryChange}
//                           required
//                         />
//                       </div>
//                       <div className="field-group">
//                         <label>Email Address *</label>
//                         <input
//                           type="email"
//                           name="emailAddress"
//                           placeholder="your@email.com"
//                           value={enquiryData.emailAddress}
//                           onChange={handleEnquiryChange}
//                           required
//                         />
//                       </div>
//                     </div>

//                     <div className="form-row-2col">
//                       <div className="field-group">
//                         <label>Mobile Number *</label>
//                         <input
//                           type="tel"
//                           name="mobileNumber"
//                           placeholder="+91 XXXXX XXXXX"
//                           value={enquiryData.mobileNumber}
//                           onChange={handleEnquiryChange}
//                           required
//                         />
//                       </div>
//                       <div className="field-group">
//                         <label>Alternative Mobile Number</label>
//                         <input
//                           type="tel"
//                           name="alternativeMobileNumber"
//                           placeholder="+91 XXXXX XXXXX (Optional)"
//                           value={enquiryData.alternativeMobileNumber}
//                           onChange={handleEnquiryChange}
//                         />
//                       </div>
//                       <div className="field-group">
//                         <label>Highest Qualification *</label>
//                         <select
//                           name="highestQualification"
//                           value={enquiryData.highestQualification}
//                           onChange={handleEnquiryChange}
//                           required
//                         >
//                           {qualifications.map((q, idx) => (
//                             <option key={idx} value={q}>{q}</option>
//                           ))}
//                         </select>
//                       </div>
//                     </div>

//                     <div className="form-row-2col">
//                       <div className="field-group">
//                         <label>State *</label>
//                         <select
//                           name="state"
//                           value={enquiryData.state}
//                           onChange={handleEnquiryChange}
//                           required
//                         >
//                           {indianStates.map((st, idx) => (
//                             <option key={idx} value={st}>{st}</option>
//                           ))}
//                         </select>
//                       </div>
//                       <div className="field-group">
//                         <label>City</label>
//                         <input
//                           type="text"
//                           name="city"
//                           placeholder="Your city"
//                           value={enquiryData.city}
//                           onChange={handleEnquiryChange}
//                         />
//                       </div>
//                     </div>

//                     <div className="form-row-2col">
//                       <div className="field-group">
//                         <label>Program Interested In *</label>
//                         <select
//                           name="programInterested"
//                           value={enquiryData.programInterested}
//                           onChange={handleEnquiryChange}
//                           required
//                           disabled={loadingCourses}
//                         >
//                           {loadingCourses ? (
//                             <option>Loading courses...</option>
//                           ) : (
//                             courses.map((course) => (
//                               <option key={course.id} value={course.course_name}>
//                                 {course.course_name}
//                               </option>
//                             ))
//                           )}
//                         </select>
//                       </div>
//                       <div className="field-group">
//                         <label>Working Professional?</label>
//                         <select
//                           name="isWorkingProfessional"
//                           value={enquiryData.isWorkingProfessional}
//                           onChange={handleEnquiryChange}
//                         >
//                           <option value="No">No</option>
//                           <option value="Yes">Yes</option>
//                         </select>
//                       </div>
//                     </div>

//                     <div className="field-group full-width">
//                       <label>Additional Message</label>
//                       <textarea
//                         name="additionalMessage"
//                         rows="3"
//                         placeholder="Any specific questions..."
//                         value={enquiryData.additionalMessage}
//                         onChange={handleEnquiryChange}
//                       ></textarea>
//                     </div>

//                     <button type="submit" className="btn-blue-action" disabled={submitting}>
//                       <span className="icon">✈</span> {submitting ? 'Submitting...' : 'Submit Enquiry'}
//                     </button>

//                   </form>
//                 </div>
//               )}

//               {/* FORM 2: Send Us a Message Form */}
//               {activeTab === 'message' && (
//                 <div className="form-card-shell">
//                   <div className="card-top-blue">
//                     <h3>Send Us a Message</h3>
//                     <p>We respond within 2 business days</p>
//                   </div>

//                   <form onSubmit={handleContactSubmit} className="card-body-padding">
                    
//                     <div className="form-row-2col">
//                       <div className="field-group">
//                         <label>Full Name *</label>
//                         <input
//                           type="text"
//                           name="fullName"
//                           placeholder="Your full name"
//                           value={messageData.fullName}
//                           onChange={handleMessageChange}
//                           required
//                         />
//                       </div>
//                       <div className="field-group">
//                         <label>Email Address *</label>
//                         <input
//                           type="email"
//                           name="emailAddress"
//                           placeholder="your@email.com"
//                           value={messageData.emailAddress}
//                           onChange={handleMessageChange}
//                           required
//                         />
//                       </div>
//                     </div>

//                     <div className="form-row-2col">
//                       <div className="field-group">
//                         <label>Phone Number</label>
//                         <input
//                           type="tel"
//                           name="phoneNumber"
//                           placeholder="+91 XXXXX XXXXX"
//                           value={messageData.phoneNumber}
//                           onChange={handleMessageChange}
//                         />
//                       </div>
//                       <div className="field-group">
//                         <label>Subject *</label>
//                         <select
//                           name="subject"
//                           value={messageData.subject}
//                           onChange={handleMessageChange}
//                           required
//                         >
//                           {subjects.map((sub, idx) => (
//                             <option key={idx} value={sub}>{sub}</option>
//                           ))}
//                         </select>
//                       </div>
//                     </div>

//                     <div className="field-group full-width">
//                       <label>Your Message *</label>
//                       <textarea
//                         name="message"
//                         rows="4"
//                         placeholder="Describe your query in detail..."
//                         value={messageData.message}
//                         onChange={handleMessageChange}
//                         required
//                       ></textarea>
//                     </div>

//                     <button type="submit" className="btn-blue-action" disabled={submitting}>
//                       <span className="icon">✈</span> {submitting ? 'Sending...' : 'Send Message'}
//                     </button>

//                   </form>
//                 </div>
//               )}

//             </div>

//           </div>
//         </section>
//         <section className="contact-fullwidth-map-section">
//           <div className="fullwidth-map-header">
//             <h2>Locate Us on Google Maps</h2>
//             <p>Alagappa University Study Center — Thiruvannamalai, Tamil Nadu</p>
//           </div>

//           <div className="fullwidth-map-wrapper">
//             <iframe
//               title="Alagappa University Study Center - Google Maps"
//               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3900.3898336526113!2d78.9486782!3d12.1538413!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bacc1169e7a22bf%3A0x603ea3c5e134b4ce!2sAlagappa%20University%20Study%20Center!5e0!3m2!1sen!2sin!4v1786788756477!5m2!1sen!2sin"
//               width="100%"
//               height="450"
//               style={{ border: 0, display: 'block' }}
//               allowFullScreen=""
//               loading="lazy"
//               referrerPolicy="strict-origin-when-cross-origin"
//             ></iframe>
//           </div>
//         </section>

//       </div>
//       <FooterSection />
//     </>
//   );
// }


import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from './Navbar';
import FooterSection from './FooterSection';
import './ContactEnquiryPage.css';

export default function ContactEnquiryPage() {
  const [activeTab, setActiveTab] = useState('enquiry'); // 'enquiry' | 'message'
  
  // Dynamic Courses for Enquiry Form
  const [courses, setCourses] = useState([]);
  const [loadingCourses, setLoadingCourses] = useState(true);

  // Dynamic Contact Center Information
  const [contactInfo, setContactInfo] = useState(null);
  const [loadingContact, setLoadingContact] = useState(true);

  // States for Admission Enquiry Form
  const [enquiryData, setEnquiryData] = useState({
    studentName: '',
    emailAddress: '',
    mobileNumber: '',
    alternativeMobileNumber: '',
    highestQualification: 'Graduate (UG)',
    state: 'Tamil Nadu',
    city: '',
    programInterested: '',
    isWorkingProfessional: 'No',
    additionalMessage: ''
  });

  // States for Send Message Form
  const [messageData, setMessageData] = useState({
    fullName: '',
    emailAddress: '',
    phoneNumber: '',
    subject: 'General Enquiry',
    message: ''
  });

  const [alert, setAlert] = useState({ type: '', message: '' });
  const [submitting, setSubmitting] = useState(false);

  const indianStates = [
    'Tamil Nadu', 'Andhra Pradesh', 'Karnataka', 'Kerala', 'Telangana',
    'Maharashtra', 'Gujarat', 'Delhi', 'Puducherry', 'West Bengal',
    'Uttar Pradesh', 'Bihar', 'Rajasthan', 'Punjab', 'Haryana'
  ];

  const qualifications = [
    '10th Pass',
    '10+2 / Higher Secondary',
    'Diploma',
    'Graduate (UG)',
    'Post Graduate (PG)',
    'Doctorate / Ph.D.'
  ];

  const subjects = [
    'General Enquiry',
    'Fee Structure & Payment',
    'Certificates & Transcripts',
    'Course Details & Syllabus',
    'Exam & Results',
    'Technical / Portal Support'
  ];

  // Fetch courses and contact center details dynamically
  useEffect(() => {
    const fetchInitialData = async () => {
      // 1. Fetch Courses
      try {
        const res = await fetch('https://metapi.emedhatechnologies.com/api/courses/courses');
        const data = await res.json();
        if (data.success && data.data.length > 0) {
          setCourses(data.data);
          setEnquiryData((prev) => ({ ...prev, programInterested: data.data[0].course_name }));
        }
      } catch (err) {
        console.error('Error loading courses:', err);
      } finally {
        setLoadingCourses(false);
      }

      // 2. Fetch Contact Center Data
      try {
        const contactRes = await fetch('https://metapi.emedhatechnologies.com/api/students/contacts');
        const contactData = await contactRes.json();
        if (contactData.success && contactData.data && contactData.data.length > 0) {
          setContactInfo(contactData.data[0]);
        }
      } catch (err) {
        console.error('Error loading contact info:', err);
      } finally {
        setLoadingContact(false);
      }
    };

    fetchInitialData();
  }, []);

  const handleEnquiryChange = (e) => {
    setEnquiryData({ ...enquiryData, [e.target.name]: e.target.value });
  };

  const handleMessageChange = (e) => {
    setMessageData({ ...messageData, [e.target.name]: e.target.value });
  };

  // Submit Admission Enquiry Form
  const handleEnquirySubmit = async (e) => {
    e.preventDefault();
    setAlert({ type: '', message: '' });
    setSubmitting(true);

    try {
      const res = await fetch('https://metapi.emedhatechnologies.com/api/students/enquiry/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(enquiryData)
      });
      const data = await res.json();

      if (data.success) {
        setAlert({ type: 'success', message: data.message });
        setEnquiryData({
          studentName: '',
          emailAddress: '',
          mobileNumber: '',
          alternativeMobileNumber: '',
          highestQualification: 'Graduate (UG)',
          state: 'Tamil Nadu',
          city: '',
          programInterested: courses[0]?.course_name || '',
          isWorkingProfessional: 'No',
          additionalMessage: ''
        });
      } else {
        setAlert({ type: 'error', message: data.message || 'Submission failed.' });
      }
    } catch (err) {
      setAlert({ type: 'error', message: 'Server error. Please try again later.' });
    } finally {
      setSubmitting(false);
    }
  };

  // Submit Contact Message Form
  const handleContactSubmit = async (e) => {
    e.preventDefault();
    setAlert({ type: '', message: '' });
    setSubmitting(true);

    try {
      const res = await fetch('https://metapi.emedhatechnologies.com/api/students/contact/message', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(messageData)
      });
      const data = await res.json();

      if (data.success) {
        setAlert({ type: 'success', message: data.message });
        setMessageData({
          fullName: '',
          emailAddress: '',
          phoneNumber: '',
          subject: 'General Enquiry',
          message: ''
        });
      } else {
        setAlert({ type: 'error', message: data.message || 'Submission failed.' });
      }
    } catch (err) {
      setAlert({ type: 'error', message: 'Server error. Please try again later.' });
    } finally {
      setSubmitting(false);
    }
  };

  // Clean phone number for WhatsApp link
  const rawPhone = contactInfo?.phone ? contactInfo.phone.replace(/[^0-9]/g, '') : '7810027373';
  const whatsappNumber = rawPhone.startsWith('91') ? rawPhone : `91${rawPhone}`;

  return (
    <>
      <Navbar />
      <div className="contact-page-wrapper">
        
        {/* Header Hero Banner */}
        <section className="contact-hero-banner">
          <div className="banner-inner-container">
            <nav className="breadcrumb-nav">
              <Link to="/" className="breadcrumb-link">Home</Link> / <span>Contact &amp; Enquiry</span>
            </nav>
            <h1>Contact &amp; Enquiry</h1>
            <p>Reach out to CDOE, EDULEARNER — we are here to help you.</p>
          </div>
        </section>

        {/* Dual Layout Section */}
        <section className="contact-main-body">
          <div className="contact-container grid-dual-layout">
            
            {/* LEFT SIDEBAR: Dynamic Get In Touch Info */}
            <div className="contact-sidebar-info">
              <h2 className="sidebar-heading">Get in Touch</h2>

              {/* Address Block */}
              <div className="info-item-block">
                <div className="info-icon-box">📍</div>
                <div className="info-text-box">
                  <h4>Address</h4>
                  {loadingContact ? (
                    <p>Loading address...</p>
                  ) : contactInfo?.address ? (
                    <p>
                      {contactInfo.address.split('\n').map((line, index) => (
                        <React.Fragment key={index}>
                          {line}
                          <br />
                        </React.Fragment>
                      ))}
                    </p>
                  ) : (
                    <p>
                      Alagappa University StudyCentre Centre for Distance and Online Education,<br />
                      EDULEARNER Main Campus,<br />
                      Thiruvannamalai – 606707,<br />
                      Tamil Nadu, India
                    </p>
                  )}
                </div>
              </div>

              {/* Phone Block */}
              <div className="info-item-block">
                <div className="info-icon-box">📞</div>
                <div className="info-text-box">
                  <h4>Phone</h4>
                  {loadingContact ? (
                    <p>Loading contact number...</p>
                  ) : contactInfo?.phone ? (
                    <>
                      <p>
                        <a href={`tel:${contactInfo.phone.trim()}`} style={{ color: 'inherit', textDecoration: 'none' }}>
                          +91 {contactInfo.phone}
                        </a>
                      </p>
                    </>
                  ) : (
                    <>
                      <p>+91 7810027373</p>
                    </>
                  )}
                </div>
              </div>

              {/* Email Block */}
              <div className="info-item-block">
                <div className="info-icon-box">✉️</div>
                <div className="info-text-box">
                  <h4>Email</h4>
                  {loadingContact ? (
                    <p>Loading email...</p>
                  ) : contactInfo?.email ? (
                    <p>
                      <a href={`mailto:${contactInfo.email}`} style={{ color: 'inherit', textDecoration: 'none' }}>
                        {contactInfo.email}
                      </a>
                    </p>
                  ) : (
                    <p>
                      <a href="mailto:meteduinstitute@gmail.com" style={{ color: 'inherit', textDecoration: 'none' }}>
                        meteduinstitute@gmail.com
                      </a>
                    </p>
                  )}
                </div>
              </div>

              {/* Office Hours Block */}
              <div className="info-item-block">
                <div className="info-icon-box">⏰</div>
                <div className="info-text-box">
                  <h4>Office Hours</h4>
                  {loadingContact ? (
                    <p>Loading office hours...</p>
                  ) : contactInfo?.office_hours ? (
                    <p>{contactInfo.office_hours}</p>
                  ) : (
                    <p>Monday – Saturday: 9:30 AM – 6:00 PM</p>
                  )}
                  <p className="closed-tag">Sunday: Closed</p>
                </div>
              </div>

              {/* Social Links */}
              <div className="social-links-block">
                <h4>Follow Us</h4>
                <div className="social-icons-row">
                  
                  {/* WhatsApp */}
                  <a 
                    href={`https://wa.me/${whatsappNumber}`} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="social-pill whatsapp" 
                    aria-label="WhatsApp"
                    title="WhatsApp"
                  >
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91C2.13 13.66 2.59 15.36 3.45 16.86L2.05 22L7.3 20.62C8.75 21.41 10.38 21.83 12.04 21.83C17.5 21.83 21.95 17.38 21.95 11.92C21.95 9.27 20.92 6.78 19.05 4.91C17.18 3.03 14.69 2 12.04 2M12.05 3.67C14.25 3.67 16.31 4.53 17.87 6.09C19.42 7.65 20.28 9.72 20.28 11.92C20.28 16.46 16.58 20.15 12.04 20.15C10.56 20.15 9.11 19.76 7.85 19L7.55 18.83L4.43 19.65L5.26 16.61L5.06 16.29C4.24 15 3.8 13.47 3.8 11.91C3.81 7.37 7.5 3.67 12.05 3.67M9.53 7.5C9.35 7.5 9.06 7.57 8.81 7.84C8.56 8.11 7.85 8.78 7.85 10.14C7.85 11.5 8.84 12.82 8.98 13C9.11 13.19 10.79 15.79 13.35 16.9C15.48 17.82 15.91 17.63 16.37 17.59C16.83 17.55 17.85 16.99 18.06 16.4C18.27 15.81 18.27 15.3 18.21 15.2C18.15 15.09 18 15.03 17.72 14.89C17.44 14.75 16.08 14.08 15.82 14C15.56 13.9 15.38 13.85 15.2 14.12C15.02 14.39 14.5 15.03 14.34 15.22C14.18 15.4 14.03 15.42 13.75 15.28C13.47 15.15 12.57 14.85 11.5 13.9C10.67 13.16 10.11 12.24 9.95 11.96C9.79 11.69 9.93 11.54 10.07 11.4C10.2 11.27 10.35 11.07 10.5 10.9C10.64 10.73 10.69 10.6 10.78 10.42C10.87 10.23 10.83 10.07 10.76 9.93C10.69 9.8 10.16 8.5 9.94 7.97C9.72 7.45 9.5 7.52 9.35 7.51L8.98 7.5H9.53Z"/>
                    </svg>
                  </a>

                  {/* Instagram */}
                  <a 
                    href="https://www.instagram.com/alagappauniversitytpet?igsh=dWQxNzJqdGx4b2Vu" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="social-pill instagram" 
                    aria-label="Instagram"
                    title="Instagram"
                  >
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                    </svg>
                  </a>

                  {/* Facebook */}
                  <a 
                    href="https://www.facebook.com/share/1DBkWkki8w/" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="social-pill facebook" 
                    aria-label="Facebook"
                    title="Facebook"
                  >
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M22.675 0h-21.35c-.732 0-1.325.593-1.325 1.325v21.351c0 .731.593 1.324 1.325 1.324h11.495v-9.294h-3.128v-3.622h3.128v-2.671c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.795.143v3.24l-1.918.001c-1.504 0-1.795.715-1.795 1.763v2.313h3.587l-.467 3.622h-3.12v9.293h6.116c.73 0 1.323-.593 1.323-1.325v-21.35c0-.732-.593-1.325-1.325-1.325z"/>
                    </svg>
                  </a>

                  {/* X (Twitter) */}
                  <a 
                    href="https://x.com/meteducentre?s=11" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="social-pill twitter-x" 
                    aria-label="X (Twitter)"
                    title="X (Twitter)"
                  >
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                    </svg>
                  </a>

                  {/* YouTube */}
                  <a 
                    href="https://youtube.com/@alagappauniversitytpet?si=Kc4m6JIioH8qUCpY" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="social-pill youtube" 
                    aria-label="YouTube"
                    title="YouTube"
                  >
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                    </svg>
                  </a>

                  {/* Google Maps Pin */}
                  <a 
                    href="https://maps.app.goo.gl/4ttrRSq6B4H4z2hAA" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="social-pill gmaps" 
                    aria-label="Google Maps"
                    title="Google Maps"
                  >
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M12 21s-8-4.5-8-11.8A8 8 0 0 1 12 2a8 8 0 0 1 8 7.2c0 7.3-8 11.8-8 11.8z"/>
                      <circle cx="12" cy="10" r="3"/>
                    </svg>
                  </a>

                </div>
              </div>

            </div>

            {/* RIGHT SIDE: Tab Toggle & Form Card */}
            <div className="contact-forms-area">
              
              {/* Tab Switch Buttons */}
              <div className="form-toggle-pill-wrapper">
                <button
                  className={`toggle-tab-btn ${activeTab === 'enquiry' ? 'active' : ''}`}
                  onClick={() => { setActiveTab('enquiry'); setAlert({ type: '', message: '' }); }}
                >
                  Admission Enquiry
                </button>
                <button
                  className={`toggle-tab-btn ${activeTab === 'message' ? 'active' : ''}`}
                  onClick={() => { setActiveTab('message'); setAlert({ type: '', message: '' }); }}
                >
                  Send a Message
                </button>
              </div>

              {/* Alert Feedback */}
              {alert.message && (
                <div className={`form-alert-box ${alert.type}`}>
                  {alert.message}
                </div>
              )}

              {/* FORM 1: Admission Enquiry Form */}
              {activeTab === 'enquiry' && (
                <div className="form-card-shell">
                  <div className="card-top-blue">
                    <h3>Admission Enquiry Form</h3>
                    <p>Our team will respond within 24 working hours</p>
                  </div>

                  <form onSubmit={handleEnquirySubmit} className="card-body-padding">
                    
                    <div className="form-row-2col">
                      <div className="field-group">
                        <label>Student Name *</label>
                        <input
                          type="text"
                          name="studentName"
                          placeholder="Full name"
                          value={enquiryData.studentName}
                          onChange={handleEnquiryChange}
                          required
                        />
                      </div>
                      <div className="field-group">
                        <label>Email Address *</label>
                        <input
                          type="email"
                          name="emailAddress"
                          placeholder="your@email.com"
                          value={enquiryData.emailAddress}
                          onChange={handleEnquiryChange}
                          required
                        />
                      </div>
                    </div>

                    <div className="form-row-2col">
                      <div className="field-group">
                        <label>Mobile Number *</label>
                        <input
                          type="tel"
                          name="mobileNumber"
                          placeholder="+91 XXXXX XXXXX"
                          value={enquiryData.mobileNumber}
                          onChange={handleEnquiryChange}
                          required
                        />
                      </div>
                      <div className="field-group">
                        <label>Alternative Mobile Number</label>
                        <input
                          type="tel"
                          name="alternativeMobileNumber"
                          placeholder="+91 XXXXX XXXXX (Optional)"
                          value={enquiryData.alternativeMobileNumber}
                          onChange={handleEnquiryChange}
                        />
                      </div>
                      <div className="field-group">
                        <label>Highest Qualification *</label>
                        <select
                          name="highestQualification"
                          value={enquiryData.highestQualification}
                          onChange={handleEnquiryChange}
                          required
                        >
                          {qualifications.map((q, idx) => (
                            <option key={idx} value={q}>{q}</option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="form-row-2col">
                      <div className="field-group">
                        <label>State *</label>
                        <select
                          name="state"
                          value={enquiryData.state}
                          onChange={handleEnquiryChange}
                          required
                        >
                          {indianStates.map((st, idx) => (
                            <option key={idx} value={st}>{st}</option>
                          ))}
                        </select>
                      </div>
                      <div className="field-group">
                        <label>City</label>
                        <input
                          type="text"
                          name="city"
                          placeholder="Your city"
                          value={enquiryData.city}
                          onChange={handleEnquiryChange}
                        />
                      </div>
                    </div>

                    <div className="form-row-2col">
                      <div className="field-group">
                        <label>Program Interested In *</label>
                        <select
                          name="programInterested"
                          value={enquiryData.programInterested}
                          onChange={handleEnquiryChange}
                          required
                          disabled={loadingCourses}
                        >
                          {loadingCourses ? (
                            <option>Loading courses...</option>
                          ) : (
                            courses.map((course) => (
                              <option key={course.id} value={course.course_name}>
                                {course.course_name}
                              </option>
                            ))
                          )}
                        </select>
                      </div>
                      <div className="field-group">
                        <label>Working Professional?</label>
                        <select
                          name="isWorkingProfessional"
                          value={enquiryData.isWorkingProfessional}
                          onChange={handleEnquiryChange}
                        >
                          <option value="No">No</option>
                          <option value="Yes">Yes</option>
                        </select>
                      </div>
                    </div>

                    <div className="field-group full-width">
                      <label>Additional Message</label>
                      <textarea
                        name="additionalMessage"
                        rows="3"
                        placeholder="Any specific questions..."
                        value={enquiryData.additionalMessage}
                        onChange={handleEnquiryChange}
                      ></textarea>
                    </div>

                    <button type="submit" className="btn-blue-action" disabled={submitting}>
                      <span className="icon">✈</span> {submitting ? 'Submitting...' : 'Submit Enquiry'}
                    </button>

                  </form>
                </div>
              )}

              {/* FORM 2: Send Us a Message Form */}
              {activeTab === 'message' && (
                <div className="form-card-shell">
                  <div className="card-top-blue">
                    <h3>Send Us a Message</h3>
                    <p>We respond within 2 business days</p>
                  </div>

                  <form onSubmit={handleContactSubmit} className="card-body-padding">
                    
                    <div className="form-row-2col">
                      <div className="field-group">
                        <label>Full Name *</label>
                        <input
                          type="text"
                          name="fullName"
                          placeholder="Your full name"
                          value={messageData.fullName}
                          onChange={handleMessageChange}
                          required
                        />
                      </div>
                      <div className="field-group">
                        <label>Email Address *</label>
                        <input
                          type="email"
                          name="emailAddress"
                          placeholder="your@email.com"
                          value={messageData.emailAddress}
                          onChange={handleMessageChange}
                          required
                        />
                      </div>
                    </div>

                    <div className="form-row-2col">
                      <div className="field-group">
                        <label>Phone Number</label>
                        <input
                          type="tel"
                          name="phoneNumber"
                          placeholder="+91 XXXXX XXXXX"
                          value={messageData.phoneNumber}
                          onChange={handleMessageChange}
                        />
                      </div>
                      <div className="field-group">
                        <label>Subject *</label>
                        <select
                          name="subject"
                          value={messageData.subject}
                          onChange={handleMessageChange}
                          required
                        >
                          {subjects.map((sub, idx) => (
                            <option key={idx} value={sub}>{sub}</option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="field-group full-width">
                      <label>Your Message *</label>
                      <textarea
                        name="message"
                        rows="4"
                        placeholder="Describe your query in detail..."
                        value={messageData.message}
                        onChange={handleMessageChange}
                        required
                      ></textarea>
                    </div>

                    <button type="submit" className="btn-blue-action" disabled={submitting}>
                      <span className="icon">✈</span> {submitting ? 'Sending...' : 'Send Message'}
                    </button>

                  </form>
                </div>
              )}

            </div>

          </div>
        </section>

        {/* Map Section */}
        <section className="contact-fullwidth-map-section">
          <div className="fullwidth-map-header">
            <h2>Locate Us on Google Maps</h2>
            <p>Alagappa University Study Center — Thiruvannamalai, Tamil Nadu</p>
          </div>

          <div className="fullwidth-map-wrapper">
            <iframe
              title="Alagappa University Study Center - Google Maps"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3900.3898336526113!2d78.9486782!3d12.1538413!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bacc1169e7a22bf%3A0x603ea3c5e134b4ce!2sAlagappa%20University%20Study%20Center!5e0!3m2!1sen!2sin!4v1786788756477!5m2!1sen!2sin"
              width="100%"
              height="450"
              style={{ border: 0, display: 'block' }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="strict-origin-when-cross-origin"
            ></iframe>
          </div>
        </section>

      </div>
      <FooterSection />
    </>
  );
}